import { useCallback, useEffect, useState } from "react";
import { fetchRewards, useAppDispatch, useAppSelector } from "state";
import useInterval from "./useInterval";
import { useToast } from "./useToast";
import { useWalletProvider } from "./useWalletProvider";
export var useRewards = function() {
    var dispatch = useAppDispatch();
    var toastError = useToast().toastError;
    var walletAddress = useWalletProvider().walletAddress;
    var ref = useAppSelector(function(state) {
        return state.rewards;
    }), endedRewards = ref.endedRewards, ongoingRewards = ref.ongoingRewards;
    var ref1 = useState(true), isLoading = ref1[0], setLoading = ref1[1];
    var refreshRewards = useCallback(function() {
        if (walletAddress) {
            return dispatch(fetchRewards(walletAddress));
        }
        return Promise.resolve();
    }, [
        dispatch,
        fetchRewards,
        walletAddress
    ]);
    useInterval(function() {
        refreshRewards();
    }, 60000);
    useEffect(function() {
        setLoading(true);
        refreshRewards().then(function(res) {
            var ref;
            setLoading(false);
            var message = (res === null || res === void 0 ? void 0 : (ref = res.error) === null || ref === void 0 ? void 0 : ref.message) || "";
            if (message) {
                toastError({
                    title: "Failed to get rewards data",
                    message: message
                });
            }
        });
    }, [
        walletAddress
    ]);
    return {
        endedRewards: endedRewards,
        ongoingRewards: ongoingRewards,
        isLoading: isLoading
    };
};
